import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE, PHONE_HREF, scrollToSection } from "./data";

const EstimateCTA = () => (
  <section data-testid="estimate-cta-section" className="grain relative overflow-hidden bg-navy py-24 sm:py-28">
    <div className="bg-grid-gold absolute inset-0" aria-hidden="true" />
    <div className="absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[130px]" aria-hidden="true" />
    <img
      src="/assets/logo_gold.webp"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 w-[620px] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-[0.07]"
    />

    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-gold sm:text-xs">Free Estimate · No Obligation</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
          READY TO <span className="text-gold-grad italic">TRANSFORM</span> YOUR SPACE?
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
          Get in touch with Teo's Painting LLC today for a FREE estimate.
        </p>
      </Reveal>
      <Reveal delay={0.26}>
        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={PHONE_HREF}
            data-testid="estimate-cta-call"
            className="flex w-full items-center justify-center gap-2.5 rounded-full border border-white/30 px-8 py-4 text-[13px] font-bold tracking-[0.14em] text-white transition-[border-color,color] duration-200 hover:border-gold hover:text-gold sm:w-auto"
          >
            <Phone size={16} /> CALL {PHONE}
          </a>
          <button
            data-testid="estimate-cta-request"
            onClick={() => scrollToSection("#contact")}
            className="w-full rounded-full bg-gold px-8 py-4 text-[13px] font-extrabold tracking-[0.14em] text-navy shadow-[0_18px_40px_-12px_rgba(212,175,55,0.55)] transition-[background-color,transform] duration-200 hover:scale-[1.04] hover:bg-gold-light sm:w-auto"
          >
            REQUEST A FREE ESTIMATE
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default EstimateCTA;
